import { useMemo, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetLoyaltyLevels } from '@/query/queries/loyalty/useGetLoyaltyLevels';
import { Tooltip } from '@/kit/new/Tooltip';
import { TOOLTIP_TEXT as TOOLTIP_TEXT_T } from './tooltip';
import IconSuccess from './assets/icon_success.svg';
import IconError from './assets/icon_error.svg';
import IconKorona from './assets/icon_korona.svg';
import IconStar from './assets/icon_star.svg';
import IconTooltip from './assets/icon_tooltip.svg';
import s from './index.module.scss';

export const LoyaltyAllStatuses = ({ currentLevel }) => {
  const { t } = useTranslation('loyalty');
  const [selected, setSelected] = useState(currentLevel);
  const { data: levels } = useGetLoyaltyLevels();
  const TOOLTIP_TEXT = TOOLTIP_TEXT_T(t);

  const features = useMemo(
    () =>
      levels
        ? levels.reduce((acc, item) => {
            const {
              window_description,
              personal_limit_description,
              personal_quota_description,
              buy_back_description,
              net_inflow_description,
              net_inflow_flag,
              p_rate_description,
              p_rate_flag,
            } = item;
            acc[item.level_slug] = {
              left: [
                window_description,
                personal_limit_description,
                personal_quota_description,
              ],
              right: [buy_back_description],
              requirements: [
                { checked: net_inflow_flag, label: net_inflow_description },
                { checked: p_rate_flag, label: p_rate_description },
              ],
            };
            return acc;
          }, {})
        : {},
    [levels],
  );

  return (
    <>
      <div className={s.benefits}>
        <h2 className="f-h3 f-500">
          {t('loyalty_levels.your_benefits_at_different_levels')}
        </h2>
        <div className={s.levels}>
          {levels?.map(lvl => (
            <div
              key={lvl.level_slug}
              onClick={() => setSelected(lvl.level_slug)}
              className={classnames(
                s.level,
                currentLevel === lvl.level_slug && s.level_current,
                selected === lvl.level_slug && s.level_active,
                'f-body',
              )}
            >
              {lvl.level_name}
            </div>
          ))}
        </div>
        <div className={s.features}>
          <div className={s.feature}>
            <div className={s.feature_header}>
              <img src={IconKorona} alt="icon" />
              <p className="f-body f-500">
                {t('loyalty_levels.group_b_early_access')}
              </p>
              <Tooltip id="early_access" content={TOOLTIP_TEXT.early_access}>
                <img
                  src={IconTooltip}
                  alt="icon"
                  width={24}
                  height={24}
                  style={{ minWidth: '24px' }}
                />
              </Tooltip>
            </div>
            <ul className={classnames(s.feature_list, 'f-label')}>
              {features[selected]?.left.map((item, index) => (
                <li key={`${selected}_${index}`}>{item}</li>
              ))}
            </ul>
          </div>
          <div className={s.feature}>
            <div className={s.feature_header}>
              <img src={IconStar} alt="icon" />
              <p className="f-body f-500">
                {t('loyalty_levels.buy_back_priority')}
              </p>
              <Tooltip id="buy_back" content={TOOLTIP_TEXT.buy_back}>
                <img
                  src={IconTooltip}
                  alt="icon"
                  width={24}
                  height={24}
                  style={{ minWidth: '24px' }}
                />
              </Tooltip>
            </div>
            <ul className={classnames(s.feature_list, 'f-label')}>
              {features[selected]?.right.map((item, index) => (
                <li key={`${selected}_${index}`}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className={s.requirements}>
        <h3 className="f-h3 f-500">{t('loyalty_levels.level_requirements')}</h3>
        {selected === 'starter' ? (
          <div className={classnames(s.requirement, 'f-label')}>
            {t('loyalty_levels.basic_level_within_3_months')}
          </div>
        ) : (
          features[selected]?.requirements.map((requirement, index) => (
            <div key={`${selected}_${index}`} className={s.requirement}>
              <img
                src={requirement.checked ? IconSuccess : IconError}
                alt="icon"
                width={24}
                height={24}
                style={{ minWidth: '24px' }}
              />
              <div className="f-label">{requirement.label}</div>
            </div>
          ))
        )}
      </div>
    </>
  );
};
